import { render, staticRenderFns } from "./OppoConfigData.vue?vue&type=template&id=fb88e364&"
import script from "./OppoConfigData.vue?vue&type=script&lang=js&"
export * from "./OppoConfigData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports